// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__fNM3P","rootCenter":"LoadMoreObserver_rootCenter__3XvI7","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1x26Z"};